export default __webpack_public_path__ + "static/media/redux.2584d504.svg";